<template>
  <div
    v-ripple
    :class="[$style.item, isSelected ? $style.select : '']"
    @click="onClick"
  >
    <div class="d-flex align-center">
      <component
        :is="iconComponent"
        :class="['icon', !item.icon ? $style.bullet : $style.icon]"
      />
      <span class="mr-3 font-l">{{ item.title }}</span>
    </div>

    <div v-if="item.children">
      <span
        :class="['mdi', item.isOpen ? 'mdi-chevron-down' : 'mdi-chevron-left']"
      ></span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NavigationItem } from "~/types/component";

type PropType = {
  item: NavigationItem;
  isSelected?: boolean;
};
type EmitType = {
  (e: "toggle"): void;
  (e: "select"): void;
};

const { item, isSelected = false } = defineProps<PropType>();
const emit = defineEmits<EmitType>();

const iconComponent = computed(() => (item.icon ? item.icon : "svgo-bullet"));

const onClick = () => {
  if (!item.children) {
    return;
  }
  emit("toggle");
};
</script>

<style lang="scss" module>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  color: $neutral-800;
  padding: 0 $space-l;
  margin: $space-xl 0;
  cursor: pointer;
  border-radius: $radius-l;
}
.select {
  background-color: $primary;
  color: white;
  :global(.icon) {
    stroke: white !important;
    * {
      stroke: white !important;
    }
  }
}
.bullet {
  height: 10px;
}
.icon {
  height: $space-xxl;
  width: $space-xxl;
}
</style>
